import { bingeCollections, trendingTitles } from "@/mocks/anime";

export default function BingeZone() {
  return (
    <section id="binge" className="section-pad bg-background-100/60">
      <div className="container-site">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="text-xs font-medium uppercase tracking-widest text-accent-600">Binge Mode</span>
            <h2 className="mt-1 font-heading text-3xl md:text-4xl">全集连播专区 · 一口气开刷</h2>
            <p className="mt-2 text-sm text-foreground-600">
              精选合集按顺序自动续播，全程无广告、零卡顿，一次追完卡通动漫综合全集。
            </p>
          </div>
          <a
            href="#hot"
            className="flex w-fit items-center gap-1 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-play-list-2-line" />
            进入连播队列
          </a>
        </div>

        <div className="mt-8 grid gap-5 md:grid-cols-3">
          {bingeCollections.map((col) => (
            <a
              key={col.id}
              href="#update"
              className={`group relative flex min-h-[280px] flex-col justify-end overflow-hidden rounded-3xl bg-gradient-to-br ${col.gradient} p-6 card-shadow transition-transform duration-300 hover:-translate-y-1.5`}
            >
              <img
                src={col.image}
                alt={`${col.title} 卡通动漫综合全集连播`}
                className="absolute inset-0 h-full w-full object-cover opacity-40 transition-opacity duration-500 group-hover:opacity-25"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/20 to-transparent" />
              <div className="relative z-10">
                <span className="flex w-fit items-center gap-1 rounded-full bg-background-50/20 px-3 py-1 text-[11px] text-background-50 backdrop-blur-sm">
                  <i className="ri-play-circle-fill text-secondary-400" />
                  连播模式已开启
                </span>
                <h3 className="mt-3 font-heading text-2xl text-background-50">{col.title}</h3>
                <p className="mt-2 text-xs leading-relaxed text-background-100/85">{col.desc}</p>
                <div className="mt-4 flex items-center gap-3 text-xs text-background-100/80">
                  <span className="rounded-full bg-background-50/15 px-2.5 py-1">{col.total}</span>
                  <span className="rounded-full bg-background-50/15 px-2.5 py-1">{col.playtime}</span>
                  <span className="ml-auto flex items-center gap-1 text-background-50">
                    立即开刷
                    <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-8 overflow-hidden rounded-2xl border border-background-200 bg-background-50 py-4">
          <p className="mb-3 px-5 text-xs font-medium uppercase tracking-widest text-foreground-500">
            <i className="ri-fire-line mr-1 text-primary-500" />
            一口气热播榜
          </p>
          <div className="relative flex overflow-hidden" aria-hidden="true">
            <div className="marquee-track flex shrink-0 items-center gap-3 pr-3">
              {[...trendingTitles, ...trendingTitles].map((t, i) => (
                <span
                  key={`${t}-${i}`}
                  className="flex shrink-0 items-center gap-2 whitespace-nowrap rounded-full bg-background-100 px-4 py-1.5 text-sm text-foreground-700"
                >
                  <i className="ri-play-mini-fill text-primary-500" />
                  {t}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}